import { Tabs, TabsList, TabsTrigger } from '@startupquickstart/frontend';
import { List, Map as MapIcon } from 'lucide-react';

export type MapView = 'list' | 'map';

interface MapViewToggleProps {
  view: MapView;
  onViewChange: (view: MapView) => void;
}

/**
 * Shared List / Map segmented toggle, used on the event, template, and library
 * challenge surfaces so the "see them on a map" affordance looks and behaves the
 * same everywhere.
 */
export function MapViewToggle({ view, onViewChange }: MapViewToggleProps) {
  return (
    <Tabs value={view} onValueChange={(value) => onViewChange(value as MapView)}>
      <TabsList>
        <TabsTrigger value="list">
          <List className="h-4 w-4" /> List
        </TabsTrigger>
        <TabsTrigger value="map">
          <MapIcon className="h-4 w-4" /> Map
        </TabsTrigger>
      </TabsList>
    </Tabs>
  );
}
